import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, HeadContent } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { useState } from 'react'
import { useSession } from '@/entities/session'
import { AppShell } from '@/widgets/app-shell'
import { CommandPalette } from '@/widgets/command-palette'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  // Дефолтный тайтл; страницы уточняют через свой head (формат «Раздел · …»).
  head: () => ({ meta: [{ title: 'STIT Телемост' }] }),
  component: RootLayout,
})

// Overlay-виджет (⌘K-палитра) монтируется здесь (page→widgets), а не в AppShell:
// widget→widget запрещён. Открытие — из шапки AppShell пропом; палитра живёт
// только у сотрудника: гостю поиск встреч недоступен, а в customer-режиме поиск —
// осознанная не-цель фазы (`plan-customer/00-architecture § 6`).
function RootLayout() {
  const [searchOpen, setSearchOpen] = useState(false)
  const { isAuthenticated, session } = useSession()
  const employee = isAuthenticated && session?.kind !== 'customer'
  return (
    <>
      <HeadContent />
      <AppShell onOpenSearch={() => setSearchOpen(true)} />
      {employee && <CommandPalette open={searchOpen} onOpenChange={setSearchOpen} />}
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  )
}
